var mp = mp || {};

// Slider - Hero
//-----------------------------------------------------------------
mp.sliderHero = function () {
    var $slider = $(".hero__slider .slider");

    if (!$slider.length) {
        return;
    }

    $slick = $slider.slick({
        autoplay: true,
        autoplaySpeed: 3000,
        fade: true,
        arrows: false,
        dots: false,
        speed: 1000,
        pauseOnFocus: false,
        pauseOnHover: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        rows: 0,
        prevArrow:
            '<button type="button" class="slick-prev slick-arrow"></button>',
        nextArrow:
            '<button type="button" class="slick-next slick-arrow"></button>',
    });
};

// Slider - Categories
//-----------------------------------------------------------------
mp.sliderCategories = function () {
    var $slider = $(".categories__slider .slider");

    if (!$slider.length) {
        return;
    }

    $slick = $slider.slick({
        autoplay: true,
        autoplaySpeed: 5000,
        fade: false,
        arrows: true,
        dots: false,
        speed: 1000,
        pauseOnFocus: false,
        pauseOnHover: false,
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        centerMode: false,
        rows: 0,
        prevArrow:
            '<button type="button" class="slick-prev slick-arrow"></button>',
        nextArrow:
            '<button type="button" class="slick-next slick-arrow"></button>',
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 820,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 540,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    });
};

// Slider - Products
//-----------------------------------------------------------------
mp.sliderProducts = function () {
    var $slider = $(".products__slider .slider");

    if (!$slider.length) {
        return;
    }

    $slick = $slider.slick({
        autoplay: false,
        autoplaySpeed: 5000,
        fade: false,
        arrows: false,
        dots: true,
        speed: 1000,
        pauseOnFocus: false,
        pauseOnHover: false,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        centerMode: false,
        rows: 0,
        prevArrow:
            '<button type="button" class="slick-prev slick-arrow"></button>',
        nextArrow:
            '<button type="button" class="slick-next slick-arrow"></button>',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                },
            },
            {
                breakpoint: 820,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 540,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    });
};

// Slider - Products Single
//-----------------------------------------------------------------
mp.sliderProductGallery = function () {
    var $slider = $(".products__main_gallery .slider_main");
    var $slider_nav = $(".products__main_gallery .slider_nav");

    if (!$slider.length) {
        return;
    }

    $slider.slick({
        asNavFor: ".products__main_gallery .slider_nav",
        fade: true,
        arrows: true,
        dots: false,
        pauseOnFocus: false,
        pauseOnHover: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        rows: 0,
        prevArrow:
            '<button type="button" class="slick-prev slick-arrow"></button>',
        nextArrow:
            '<button type="button" class="slick-next slick-arrow"></button>',
    });

    $slider_nav.slick({
        asNavFor: ".products__main_gallery .slider_main",
        arrows: false,
        dots: false,
        slidesToShow: 6,
        slidesToScroll: 1,
        focusOnSelect: true,
        centerMode: false,
        centerPadding: "0",
        rows: 0,
        prevArrow:
            '<button type="button" class="slick-prev slick-arrow"></button>',
        nextArrow:
            '<button type="button" class="slick-next slick-arrow"></button>',
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 820,
                settings: {
                    slidesToShow: 6,
                },
            },
            {
                breakpoint: 520,
                settings: {
                    slidesToShow: 3,
                },
            },
        ],
    });
};

$(document).ready(function () {
    mp.sliderHero();
    mp.sliderProducts();
    mp.sliderCategories();
    mp.sliderProductGallery();
});
